import styled from 'styled-components';

import { colorWhite, colorPrimary, colorAccent } from 'styles';

export const MobileDatePickerWrapper = styled.label`
  display: inline-flex;
  align-items: center;
  position: relative;
  padding-bottom: 16px;
  color: ${colorAccent};

  & > svg {
    transform: rotate(0deg);
    margin-left: 8px;
    fill: ${colorAccent};
  }
`;

export const MobileDataPickerLabel = styled.span`
  font-size: 14px;
`;

export const MobileDatePicker = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  opacity: 0;
  cursor: pointer;
  font-size: 16px;

  &:focus {
    outline: 0;
  }

  /* stylelint-disable-next-line */
  &::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    cursor: pointer;
    opacity: 0;
  }

  ::-webkit-clear-button {
    display: none;
  }

  ::-ms-clear {
    display: none;
  }
`;

export const SelectLabel = styled.span`
  color: ${colorAccent};
  margin-right: 8px;
  font-size: 12px;
  line-height: 16px;
`;

export const Select = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-bottom: 15px;
  background: ${colorWhite};
  border: 0;
  outline: 0;

  &:after {
    content: '';
    position: absolute;
    top: -8px;
    bottom: -8px;
    left: 0;
    right: 0;
    z-index: 1;
  }

  /* stylelint-disable */
  & > svg {
    /* stylelint-enable */
    display: block;
    margin-top: -2px;
    fill: ${colorAccent};
    transform: rotate(0deg);
  }

  &:hover {
    & > svg {
      fill: ${colorPrimary};
    }

    ${SelectLabel} {
      color: ${colorPrimary};
    }
  }

  ${({ open }) => {
    if (open) {
      return `
        & > svg {
          fill: ${colorPrimary};
          transform: rotate(180deg);
        }

        ${SelectLabel} {
          color: ${colorPrimary};
        }
      `;
    }

    return '';
  }}
`;
